export enum ReferToType {
  prime = 'prime',
  serviceProvider = 'serviceProvider',
}
